document.addEventListener("DOMContentLoaded", function () {
    const stickyAtc = document.querySelector(".sticky-atc-mobile");
    const target = document.querySelector("#multiple-products-form");
  
    if (stickyAtc && target && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.create({
        trigger: target,
        start: "top bottom-=200",   
        end: "bottom top+=200",     
        toggleClass: { targets: stickyAtc, className: "hide-sticky-atc" },
      });
    }
  });